module.exports = __webpack_public_path__ + "img/stage5.1cb7f331.png";